import axios from "axios";

// Auto-retry GETs when the server is briefly unreachable (restart / 502 / 503 / 504).
axios.interceptors.response.use(undefined, async (err) => {
  const cfg = err.config;
  const st = err.response?.status;
  const transient = !err.response || [502, 503, 504].includes(st);
  if (!cfg || (cfg.method || "get").toLowerCase() !== "get" || !transient || axios.isCancel(err)) throw err;
  cfg.__retry = (cfg.__retry || 0) + 1;
  if (cfg.__retry > 4) throw err;
  await new Promise((r) => setTimeout(r, 800 * 2 ** (cfg.__retry - 1)));
  return axios(cfg);
});

// Same auto-retry for fetch() GETs (most of the app uses fetch).
const _fetch = window.fetch.bind(window);
window.fetch = async (input, init = {}) => {
  const method = (init.method || (input instanceof Request ? input.method : "GET")).toUpperCase();
  if (method !== "GET") return _fetch(input, init);
  for (let i = 0; ; i++) {
    try {
      const res = await _fetch(input, init);
      if (![502, 503, 504].includes(res.status) || i >= 4) return res;
    } catch (e) {
      if (e.name === "AbortError" || i >= 4) throw e;
    }
    await new Promise((r) => setTimeout(r, 800 * 2 ** i));
  }
};
